import { Modules } from "../DatabaseConstants/MasterConstant";
import { Actions, RouteConstants, SideMenuItemKeys } from "./RouteConstants";

/* Allowed routes path show filters pathSegments[1] */
export const allowedDropdownList = [
  SideMenuItemKeys.DEFAULT_HOME_PAGE,
  SideMenuItemKeys.DISPLAY_QUEUE_STATUS,
  SideMenuItemKeys.DISPLAY_SCHEDULE_LIST,
  SideMenuItemKeys.MASTER_MANAGEMENT,
  SideMenuItemKeys.PARKING_HISTORY,
  SideMenuItemKeys.USER_MANAGEMENT,
  SideMenuItemKeys.MESSAGING,
  SideMenuItemKeys.REQUEST_PER_HOUR_REPORT,
  SideMenuItemKeys.VISITORS_REPORT,
  SideMenuItemKeys.ALL_USERS_PARKING_REPORT,
  SideMenuItemKeys.PARKING_DATA_COUNTS_REPORT,
  SideMenuItemKeys.ADVANCE_BOOKING_REQUEST,
  SideMenuItemKeys.IOTHUB_LOGS,
  SideMenuItemKeys.CLIENT_PARKING_AVAILABILITY_LIST,
  SideMenuItemKeys.ADVANCE_BOOKING_REQUEST_REPORT,
  SideMenuItemKeys.ABR_PENALTY_COLLECTION_REPORT
];

/* Allowed routes path show filters on Master Management pathSegments[2] */
/* undefined is important for if pathSegment[1] available but pathSegment[2] no path */
export const allowedCustomerDropdownList = [undefined, Modules.CUSTOMER_LOCATION_MASTER, Modules.CUSTOMER_CLIENT_MASTER, Modules.KEY_FOB_MASTER, Modules.KEY_FOB_ALLOCATION_MASTER, Modules.PRICING_MASTER, RouteConstants.USER_LIST_PAGE, Modules.MESSAGING, Actions.ADD_NOTIFICATION, undefined, undefined, Modules.ADVANCE_BOOKING_REQUEST_LIST, Modules.ADVANCE_BOOKING_QUOTA_MASTER, Modules.ADVANCE_BOOKING_REQUEST_REPORT, Modules.ABR_PENALTY_COLLECTION_REPORT];

export const allowedLocationDropdownList = [undefined, Modules.CUSTOMER_CLIENT_MASTER, Modules.KEY_FOB_MASTER, Modules.KEY_FOB_ALLOCATION_MASTER, Modules.PRICING_MASTER, RouteConstants.USER_LIST_PAGE, Modules.MESSAGING, Actions.ADD_NOTIFICATION, undefined, undefined, Modules.ADVANCE_BOOKING_REQUEST_LIST, Modules.ADVANCE_BOOKING_QUOTA_MASTER, Modules.ADVANCE_BOOKING_REQUEST_REPORT, Modules.ABR_PENALTY_COLLECTION_REPORT];

export enum MasterFiltersConstant {
  CUSTOMER_ID = "customerId",
  LOCATION_ID = "locationId",
  CLIENT_ID = "clientId",
  KEY_FOB_ID = "keyFobId",
  MODULE_ID = "moduleId",
  REFRESH = "refresh"
}
